/**
 * Ajuste inteligente de tarifa (hora pico / noche) — activable en Admin → Operación.
 * Hora local del dispositivo. Colombia: pico 7–9 y 17–20; noche 22–5.
 */
import { roundFareToHundred } from './FareCalculator';

const PEAK_WINDOWS = [
  { start: 7, end: 9 },
  { start: 17, end: 20 },
];
const NIGHT_START = 22;
const NIGHT_END = 5;

function hourInRange(h, start, end) {
  if (start <= end) return h >= start && h < end;
  return h >= start || h < end;
}

function isPeakHour(hour) {
  for (let i = 0; i < PEAK_WINDOWS.length; i++) {
    const w = PEAK_WINDOWS[i];
    if (hourInRange(hour, w.start, w.end)) return true;
  }
  return false;
}

function isNightHour(hour) {
  return hourInRange(hour, NIGHT_START, NIGHT_END);
}

/**
 * Multiplicador aplicable (1 = sin cambio). Pico y noche: el mayor de los dos si coinciden.
 */
export function resolveSmartFareMultiplier(settings, date = new Date()) {
  if (!settings || settings.smartFareEnabled !== true) return 1;
  const peak = parseFloat(settings.smartFarePeakMult);
  const night = parseFloat(settings.smartFareNightMult);
  const peakMult = Number.isFinite(peak) && peak >= 1 ? peak : 1.15;
  const nightMult = Number.isFinite(night) && night >= 1 ? night : 1.2;
  const hour = date.getHours();
  let mult = 1;
  if (isPeakHour(hour)) mult = Math.max(mult, peakMult);
  if (isNightHour(hour)) mult = Math.max(mult, nightMult);
  return mult;
}

/**
 * Aplica multiplicador al resultado de FareCalculator (total + comisión).
 */
export function applySmartFareToTotals(fare, rateDetails, settings, date = new Date()) {
  const mult = resolveSmartFareMultiplier(settings, date);
  if (!(mult > 1) || !fare || fare.error) {
    return { ...fare, smartFareMultiplier: 1 };
  }
  const totalCost = roundFareToHundred((parseFloat(fare.totalCost) || 0) * mult);
  let convenience_fees = 0;
  const convFees = parseFloat(rateDetails?.convenience_fees) || 0;
  if (rateDetails?.convenience_fee_type === 'flat') {
    convenience_fees = convFees;
  } else {
    convenience_fees = (totalCost * convFees) / 100;
  }
  const grandTotal = roundFareToHundred(totalCost + convenience_fees);
  convenience_fees = Math.max(0, grandTotal - totalCost);
  return {
    ...fare,
    totalCost,
    grandTotal,
    convenience_fees,
    smartFareMultiplier: mult,
  };
}
